export default "__VITE_ASSET__DMKBC$Xn__"